<template>
  <div>
    <b-row>
      <b-col md="11">
        <div v-if="ams_data.attributes">
          <b-jumbotron header-level="4" bg-variant="medium" text-variant="dark" border-variant="dark">
              <template #header>{{'$' + ( ams_data.attributes['asking-price-cents']/ 100).toFixed(2)}}</template>
              <template #lead>
                {{ams_data.attributes['description']}}
              </template>
              <value-rating :product_item="ams_data.attributes"></value-rating>
              <five-star-rating v-model="ams_data.attributes['estimated-quality']"></five-star-rating>
              <hr text-variant="white" class="my-4">
              <template>
                <b-card md="1" bg-variant="medium" body-bg-variant="medium"> {{description}}</b-card>
              </template>
          </b-jumbotron>
        </div>
      </b-col>
      <b-col md="1">
        <data-navagations
          :can_update="isAdminPath"
          :can_help="true"
          @update="doUpdate"
          @cancel="doCancel"
          @help="doHelp"
        ></data-navagations>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import {ADMIN_PATH, amsApiResourcePath, apiRoute, PRODUCT_ITEMS} from '@/ams_route'
import {belongsToDescription} from '@/utils'
import FiveStarRating from './FiveStarRating.vue'
import ValueRating from './ValueRating.vue'
import DataNavagations from './DataNavagations.vue'

export default {
  components: {
    FiveStarRating,
    ValueRating,
    DataNavagations
  },
  props: {
    id: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  data () {
    return {
      ams_type: PRODUCT_ITEMS,
      ams_data: {},
      description: undefined,
      describe_belongs_to: [
        {
          prepend: '',
          type: 'brands',
          description_attr: 'name',
          append: ': '
        },
        {
          prepend: '',
          type: 'product-models',
          description_attr: 'name',
          append: ' '
        },
        {
          prepend: '#',
          type: 'product-listings',
          description_attr: 'edition',
          append: ''
        },
        {
          prepend: ' of ',
          type: 'collections',
          description_attr: 'name',
          append: ''
        },
        {
          prepend: ' in ',
          type: 'storage-spaces',
          description_attr: 'location',
          append: ' Items'
        }
      ]
    }
  },
  computed: {
    isAdminPath() {
      return this.apiPath() == ADMIN_PATH
    }
  },
  methods: {
    apiPath () {
      return this.paramApiPath() || ADMIN_PATH
    },
    paramApiPath() {
      // Note $route and $router are not the same
      return this.api_path || this.$route.query?.api_path
    },
    apiResourcePath() {
      return apiRoute(amsApiResourcePath(this.apiPath(), this.ams_type), this.id)
    },
    doCancel() {
      this.$router.go(-1)
    },
    doUpdate() {
      this.$router.push( {path: '/' + this.ams_type + '/' + this.id + '/update'})
    },
    doHelp() {
      this.$router.push( {path: '/references/ProductItem/information/' + this.id})
    }
  },
  mounted () {
    http_v1.get(this.apiResourcePath(), {
    }).then(response => {
      if( response.data) {
        this.ams_data = response.data.data
        this.description = belongsToDescription(
          response.data.data, response.data.included, this.describe_belongs_to
        )
        this.$emit('gotAttrs', this.ams_data?.attributes, this.description, response.data.included.find(el => el.type === 'interests'))
      }
    }).catch(error => {
      if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
  }
}
</script>

<style scoped>
hr { background-color: white; height: 2px; border: none; }
 .card {
     border: 3px solid white;
 }
</style>
